export function formatMoney(amount) {
  amount = +amount

  return '$' + amount?.toFixed(2)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const sanitizeMoneyInput = (value) => {
  const [whole, ...decimals] = String(value ?? '').replace(/[^\d.]/g, '').split('.')

  return decimals.length ? `${whole}.${decimals.join('').slice(0, 2)}` : whole
}

export const formatLocaleAmount = (amount) => {
  if (Number.isInteger(amount)) return amount.toLocaleString()

  const cents = Math.round(amount * 100) / 100

  return Number.isInteger(cents)
    ? cents.toLocaleString()
    : cents.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
